import React from 'react';
import Txt from 'components/atoms/Txt/Txt';
import Image from 'components/atoms/Image/Image';
import { SIGN_UP, CASHBACK, FAQ } from 'components/pages/pages';
import useLocalisedImage from 'hooks/useLocalisedImage';
import whyQmeeImg1 from './assets/why_qmee_img_1.png';
import whyQmeeImg1_en_gb from './assets/why_qmee_img_1_en-gb.png';
import whyQmeeImg1_de_de from './assets/why_qmee_img_1_de-de.png';
import whyQmeeImg1_fr_fr from './assets/why_qmee_img_1_fr-fr.png';
import whyQmeeImg2 from './assets/why_qmee_img_2.png';
import whyQmeeImg2_en_gb from './assets/why_qmee_img_2_en-gb.png';
import whyQmeeImg2_de_de from './assets/why_qmee_img_2_de-de.png';
import whyQmeeImg2_fr_fr from './assets/why_qmee_img_2_fr-fr.png';
import whyQmeeImg3 from './assets/why_qmee_img_3.png';
import whyQmeeImg4 from './assets/why_qmee_img_4.png';
import whyQmeeImg4_en_gb from './assets/why_qmee_img_4_en-gb.png';
import whyQmeeImg4_de_de from './assets/why_qmee_img_4_de-de.png';
import whyQmeeImg4_fr_fr from './assets/why_qmee_img_4_fr-fr.png';
import whyQmeeImg5 from './assets/why_qmee_img_5.png';
import whyQmeeImg6 from './assets/why_qmee_img_6.png';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import SplitRowCta from 'components/organisms/SplitRow/SplitRowCta';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import StyledList from 'components/atoms/StyledList/StyledList';
import AppStoreLinks from 'components/atoms/AppStoreLinks/AppStoreLinks';
import Button from 'components/atoms/Button/Button';
import A from 'components/atoms/A/A';

export interface Props {}

const WhyQmee: React.FC<Props> = () => {
  const localisedImage = useLocalisedImage();

  return (
    <main className="fadedPageBg">
      <SplitRow
        mobileColumnOrderSwapped
        contentAlignedTop
        isFirstRow
        leftColumn={
          <>
            <Txt component="h1">Why Qmee?</Txt>
            <Txt component="h2">Earn real cash rewards</Txt>
            <StyledList>
              <Txt component="li">Real cash rewards - not swag or points.</Txt>
              <Txt component="li">
                Cashout to PayPal or Venmo anytime, with no minimum cashout amount!
              </Txt>
              <Txt component="li">Spend your rewards on a gift card or donate to charity.</Txt>
            </StyledList>
          </>
        }
        rightColumn={
          <Image
            src={localisedImage({
              global: whyQmeeImg1,
              'en-gb': whyQmeeImg1_en_gb,
              'de-de': whyQmeeImg1_de_de,
              'fr-fr': whyQmeeImg1_fr_fr,
            })}
            alt="Why Qmee?"
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Txt component="h2">Take paid surveys</Txt>
            <StyledList>
              <Txt component="li">Complete online surveys to earn cash rewards!</Txt>
              <Txt component="li">Get matched with surveys that are tailored to your profile.</Txt>
              <Txt component="li">Activate your streak to increase your earnings!</Txt>
            </StyledList>
            <SplitRowCta>
              <Button
                component={A}
                color="primary"
                buttonType="secondary"
                buttonSize="large"
                to={CASHBACK.path}
                prefetch={false}
              >
                <Txt>Start Earning</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
        leftColumn={
          <Image
            src={localisedImage({
              global: whyQmeeImg2,
              'en-gb': whyQmeeImg2_en_gb,
              'de-de': whyQmeeImg2_de_de,
              'fr-fr': whyQmeeImg2_fr_fr,
            })}
            alt="Take paid surveys"
          />
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Txt component="h2">Make money shopping online</Txt>
            <StyledList>
              <Txt component="li">Earn cashback when you buy the things you love.</Txt>
              <Txt component="li">Find deals for your favorite brands!</Txt>
              <Txt component="li">Save money by using exclusive discount codes.</Txt>
            </StyledList>
            <SplitRowCta>
              <Button
                component={A}
                color="primary"
                buttonType="secondary"
                buttonSize="large"
                to={CASHBACK.path}
                prefetch={false}
              >
                <Txt>Show me cash back deals</Txt>
              </Button>
            </SplitRowCta>
          </>
        }
        rightColumn={<Image src={whyQmeeImg3} alt="Make money shopping online" />}
      />

      <SplitRow
        rightColumn={
          <>
            <Txt component="h2">Available on-the-go</Txt>
            <StyledList>
              <Txt component="li">The mobile app is free for Android and iOS.</Txt>
              <Txt component="li">Earn extra cash anytime, anywhere!</Txt>
              <Txt component="li">
                Earn extra cash anytime, anywhere! Cashout your rewards when you&apos;re out &
                about.
              </Txt>
            </StyledList>
            <AppStoreLinks hideRating />
          </>
        }
        leftColumn={
          <Image
            src={localisedImage({
              global: whyQmeeImg4,
              'en-gb': whyQmeeImg4_en_gb,
              'de-de': whyQmeeImg4_de_de,
              'fr-fr': whyQmeeImg4_fr_fr,
            })}
            alt="Available on-the-go"
          />
        }
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Txt component="h2">Fun online community</Txt>
            <StyledList>
              <Txt component="li">Get extra rewards with our social media giveaways!</Txt>
              <Txt component="li">Social media community.</Txt>
              <Txt component="li">Follow us on social media to get important updates!</Txt>
            </StyledList>
          </>
        }
        rightColumn={<Image src={whyQmeeImg5} alt="Fun online community" />}
      />

      <SplitRow
        rightColumn={
          <>
            <Txt component="h2">We provide great support</Txt>
            <StyledList>
              <Txt component="li">Dedicated & friendly customer support team.</Txt>
              <Txt component="li">Responses from a real person.</Txt>
              <Txt component="li">Quick & helpful replies.</Txt>
            </StyledList>
          </>
        }
        leftColumn={<Image src={whyQmeeImg6} alt="We provide great support" />}
      />

      <FullWidthCta
        title={<Txt>Frequently Asked Questions</Txt>}
        ctaText="FAQ's"
        ctaLink={FAQ.path}
      >
        Check out our FAQ’s to help with any unanswered questions
      </FullWidthCta>
    </main>
  );
};

export default WhyQmee;
